import {
    CompanySettings,CurrencySettings, GeneralSettings, LicenseSettings, SettingsRegistry, UserSettings
} from "@mcleod/core";

export class ImagingSettingsInitializer {
    public initialize() {
        SettingsRegistry.get().register(
            new GeneralSettings(),
            new CompanySettings(),
            new UserSettings(),
            new LicenseSettings(),
            new CurrencySettings()
        );
    }
}
